// --- AUTO TOTAL PRICE CALCULATOR (handles Shopify quantity + total) ---
document.addEventListener('DOMContentLoaded', () => {
  const qtyInput = document.querySelector('input[name="quantity"]');
  const totalEl = document.querySelector('#total-price');
  const priceEl = document.querySelector('.text-lg'); // Adjust class if your theme differs

  if (!qtyInput || !priceEl || !totalEl) return;

  function getPrice() {
    return parseFloat(priceEl.textContent.replace(/[^\d,.-]/g, '').replace(',', '.'));
  }

  function updateTotal() {
    const unit = getPrice();
    const qty = parseInt(qtyInput.value) || 1;
    const total = (unit * qty).toFixed(2);
    totalEl.textContent = '€' + total.replace('.', ',');
  }

  qtyInput.addEventListener('input', updateTotal);
  document.querySelectorAll('button').forEach(btn =>
    btn.addEventListener('click', () => setTimeout(updateTotal, 150))
  );

  const observer = new MutationObserver(updateTotal);
  observer.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });

  setInterval(updateTotal, 500);
  updateTotal();
});


// --- DIY PAINT & COAT COVERAGE CALCULATOR ---
function initPaintCalculator() {
  const coverageInput =
    document.querySelector('#s-feet') ||
    document.querySelector('input[name*="coverage"]') ||
    document.querySelector('input[placeholder*="m"]') ||
    document.querySelector('input[placeholder*="square"]');

  const resultEl = document.querySelector('#paint-calculation-result');
  const priceData = document.querySelector('#paint-price-data');

  if (!coverageInput || !resultEl) {
    console.warn('DIY calculator: missing input or result element');
    return;
  }

  // --- Detect product name & type ---
  const productTitle = document.querySelector('h1')?.textContent?.trim() || '';
  const productTitleLower = productTitle.toLowerCase();
  const isBaseCoat = productTitleLower.includes('base coat');
  const isGripCoat = productTitleLower.includes('grip coat');
  const isTopCoat  = productTitleLower.includes('top coat');
  const isCoat = isBaseCoat || isGripCoat || isTopCoat;

  // --- Assign volumes dynamically ---
  let volSmall, volMid, volLarge;

  if (isGripCoat) {
    volSmall = 0.9;
    volMid   = 4.5;
    volLarge = 9;
  } else if (isCoat) {
    volSmall = 1;
    volMid   = 5;
    volLarge = 10;
  } else {
    volSmall = 0.9;
    volMid   = 4.5;
    volLarge = 9;
  }

  // --- Assign coverage rate ---
  const coverageRate = isCoat ? 0.2 : 0.3; // L per m²

  // --- Create fully isolated input ---
  const parent = coverageInput.parentNode;
  const safeInput = coverageInput.cloneNode(true);
  safeInput.name = 'diy-calculator-only';
  safeInput.removeAttribute('id');
  safeInput.setAttribute('autocomplete', 'off');
  safeInput.setAttribute('data-independent', 'true');
  parent.replaceChild(safeInput, coverageInput);

  const input = safeInput;

  const protectionObserver = new MutationObserver(() => {
    if (input.name !== 'diy-calculator-only') input.name = 'diy-calculator-only';
    if (input.id) input.removeAttribute('id');
  });
  protectionObserver.observe(input, { attributes: true });

  // --- Price helper ---
  function getPrice(key, fallback) {
    if (!priceData) return fallback;
    const attr = Array.from(priceData.attributes).find(a => a.name.includes(key));
    return attr ? parseFloat(attr.value) : fallback;
  }

  // --- Get correct prices for each volume type ---
  const priceSmall = isCoat ? (isGripCoat ? getPrice('09', 19) : getPrice('1l', 19)) : getPrice('09', 19);
  const priceMid   = isCoat ? (isGripCoat ? getPrice('45', 83) : getPrice('5l', 83)) : getPrice('45', 83);
  const priceLarge = isCoat ? (isGripCoat ? getPrice('9l', 145) : getPrice('10l', 145)) : getPrice('9l', 145);

  input.addEventListener('input', () => {
    const m2 = parseFloat(input.value);
    if (isNaN(m2) || m2 <= 0) {
      resultEl.textContent = '';
      return;
    }

    // --- Calculate liters needed (always keep one decimal precision) ---
    const litersNeeded = (m2 * coverageRate).toFixed(1);
    let combos = [];

    // --- Dynamically scale loop limits (up to 60 per size) ---
    const maxLarge = Math.min(Math.ceil(litersNeeded / volLarge) + 5, 60);
    const maxMid = Math.min(Math.ceil(litersNeeded / volMid) + 5, 60);
    const maxSmall = Math.min(Math.ceil(litersNeeded / volSmall) + 5, 60);

    // Generate all combinations efficiently
    for (let nLarge = 0; nLarge <= maxLarge; nLarge++) {
      for (let nMid = 0; nMid <= maxMid; nMid++) {
        for (let nSmall = 0; nSmall <= maxSmall; nSmall++) {
          const totalLiters = nLarge * volLarge + nMid * volMid + nSmall * volSmall;
          if (totalLiters >= litersNeeded) {
            const numCans = nLarge + nMid + nSmall;
            if (numCans === 0) continue;

            const productCost = nLarge * priceLarge + nMid * priceMid + nSmall * priceSmall;
            const ship = Math.max(0, numCans - 1);
            const total = productCost + ship;

            combos.push({ nLarge, nMid, nSmall, totalLiters, total, numCans });
          }
        }
      }
    }

    if (combos.length === 0) {
      resultEl.textContent = 'No valid combination found.';
      return;
    }

    combos.sort((a, b) => a.total - b.total);
    const cheapest = combos[0];

    const fewerCans = combos.filter(c =>
      c.numCans < cheapest.numCans &&
      c.totalLiters >= litersNeeded &&
      c.total <= cheapest.total * 1.15
    );

    let main = fewerCans.length > 0
      ? fewerCans.sort((a, b) => a.total - b.total)[0]
      : cheapest;

    // --- Format output (no alternative option) ---
    const mainText = [];
    if (main.nLarge > 0) mainText.push(`${main.nLarge} × ${volLarge} L`);
    if (main.nMid > 0) mainText.push(`${main.nMid} × ${volMid} L`);
    if (main.nSmall > 0) mainText.push(`${main.nSmall} × ${volSmall} L`);

    // --- Product wording ---
    let productWord = 'KULTA Lime Paint';
    if (isBaseCoat) productWord = 'KULTA Base Coat';
    else if (isGripCoat) productWord = 'KULTA Grip Coat';
    else if (isTopCoat) productWord = 'KULTA Top Coat';

    resultEl.innerHTML = `
      You’ll need approximately <strong>${litersNeeded} L</strong> of ${productWord}.<br>
      Recommended combination: <strong>${mainText.join(', ')}</strong>.
    `;
  });
}

// --- Init calculator and reapply after variant switch ---
document.addEventListener('DOMContentLoaded', initPaintCalculator);

const productForm = document.querySelector('form[action*="/cart/add"]');
if (productForm) {
  const variantObserver = new MutationObserver(() => {
    setTimeout(() => {
      const calcInput = document.querySelector('input[name="diy-calculator-only"]');
      if (!calcInput) initPaintCalculator();
    }, 300);
  });
  variantObserver.observe(productForm, { childList: true, subtree: true });
}
